import {Component, DoCheck, EventEmitter, Input, KeyValueDiffers, Output} from "@angular/core";
import _ from 'lodash';
import {DICTIONARY} from "../../../../dictionary";
import {TableQueryTemplatesService} from "../../../../services/tableQueryTemplatesService";

@Component({
	selector: 'table-query-templates-dropdown',
	templateUrl: './table-query-templates-dropdown.html',
})
export class TableQueryTemplatesDropdownComponent implements DoCheck {

	@Input() queryModalModel;
	@Output() onTemplateSelected = new EventEmitter();

	constructor(private keyValueDiffers: KeyValueDiffers,
				public tableQueryTemplatesService:TableQueryTemplatesService) {
	}

	dic = DICTIONARY;
	_ = _;
	keyValueDifferMain;
	// used to detect any changes in inner nested objects of queryModalModel
	keyValueDifferArr = [];


	ngOnInit() {
		if (this.queryModalModel) {
			// set change detection in main object
			this.keyValueDifferMain = this.keyValueDiffers.find(this.queryModalModel).create();

			// set change detection in its nested objects
			Object.keys(this.queryModalModel).forEach((key) => {
				if (typeof this.queryModalModel[key] === "object") {
					this.keyValueDifferArr.push({
						key: key,
						differ: this.keyValueDiffers.find(this.queryModalModel[key]).create()
					});
				}
			});
		}
	}

	ngDoCheck() {
		if (this.keyValueDifferMain && this.queryModalModel) {
			// check changes in main object
			let isValueChanged = false;
			let changes = this.keyValueDifferMain.diff(this.queryModalModel);
			if (changes) {
				// count only chaged items (and not removed /added items)
				changes.forEachChangedItem(change => {
					isValueChanged = true
				});
			}

			// check changes in its nested objects
			for (let i = 0; i < this.keyValueDifferArr.length; i++) {
				const differData = this.keyValueDifferArr[i];
				changes = differData.differ.diff(this.queryModalModel[differData.key]);
				if (changes) {
					// count only chaged items (and not removed /added items)
					changes.forEachChangedItem(change => {
						isValueChanged = true
					});
				}
			}

			// finally, check the detector in service
			if (isValueChanged) {
				setTimeout(() => {
					this.tableQueryTemplatesService.isSomeValueChanged = true;
				});
				return;
			}
		}
	}

	selectQueryTemplate = (templateObj) => {
		this.onTemplateSelected.emit(templateObj);
		// in setTimeout because we want to wait for changes to take place before setting isSomeValueChanged to false
		setTimeout(() => {
			this.tableQueryTemplatesService.isSomeValueChanged = false;
			this.tableQueryTemplatesService.selectedTemplate = templateObj;
		}, 60);
	}
}
